import { defineMessages } from 'react-intl'

export default defineMessages({
    export: {
        id: 'containers.CustomerPage.CustomerInfo.components.ErrorRates.components.KPI.components.DownloadCsv.export',
        defaultMessage: 'Export data',
    }
})